import { Link } from 'react-router-dom';

export default function ArticlesSection() {
  const articles = [
    {
      label: 'Guia 2026',
      title: 'Como Usar o CSSBuy Sheet Passo a Passo',
      desc: 'Aprenda a navegar na nossa planilha, encontrar os melhores produtos e fazer compras seguras para Portugal e Brasil.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20laptop%20on%20wooden%20desk%20displaying%20spreadsheet%20interface%20with%20product%20categories%20and%20links%20organized%20neatly%20soft%20morning%20light%20from%20window%20clean%20Scandinavian%20home%20office%20with%20small%20potted%20plant%20and%20notebook%20warm%20inviting%20atmosphere%20editorial%20interior%20photography%20high%20detail%20productive%20serene%20workspace%20mood&width=800&height=600&seq=article-v2-01&orientation=landscape',
      link: '/guia-cssbuy-sheet-2026',
      isInternal: true,
    },
    {
      label: 'Portugal & Brasil',
      title: 'CSSBuy Sheet Portugal e Brasil: Guia Completo 2026',
      desc: 'Tudo sobre envios, taxas e recomendações específicas para compradores em Portugal e no Brasil.',
      image: 'https://readdy.ai/api/search-image?query=Portuguese%20and%20Brazilian%20flags%20side%20by%20side%20on%20a%20modern%20minimalist%20desk%20with%20laptop%20displaying%20e%20commerce%20interface%20soft%20natural%20daylight%20from%20window%20clean%20professional%20workspace%20aesthetic%20warm%20wood%20tones%20and%20white%20surfaces%20global%20shopping%20concept%20editorial%20photography%20high%20detail%20international%20trade%20mood&width=800&height=600&seq=article-v2-02&orientation=landscape',
      link: '/cssbuy-sheet-portugal-brasil',
      isInternal: true,
    },
    {
      label: 'Top 2026',
      title: 'Melhor CSSBuy Spreadsheet Atualizado 2026',
      desc: 'Por que a nossa planilha é considerada a melhor em português? Descubra as vantagens exclusivas.',
      image: 'https://readdy.ai/api/search-image?query=Gold%20trophy%20and%20award%20certificate%20on%20modern%20white%20desk%20with%20spreadsheet%20analytics%20displayed%20on%20laptop%20screen%20soft%20natural%20lighting%20clean%20professional%20office%20aesthetic%20achievement%20and%20success%20concept%20warm%20motivational%20atmosphere%20editorial%20interior%20photography%20high%20detail%20inspiring%20workspace%20mood&width=800&height=600&seq=article-v2-03&orientation=landscape',
      link: '/melhor-cssbuy-spreadsheet-2026',
      isInternal: true,
    },
    {
      label: 'Segurança',
      title: 'CSSBuy Spreadsheet Seguro: Como Evitar Golpes',
      desc: 'Dicas essenciais para identificar vendedores confiáveis e proteger suas compras internacionais.',
      image: 'https://readdy.ai/api/search-image?query=Digital%20shield%20icon%20hovering%20above%20laptop%20keyboard%20with%20lock%20symbol%20on%20screen%20representing%20online%20security%20and%20protection%20soft%20blue%20ambient%20lighting%20clean%20minimalist%20tech%20workspace%20white%20desk%20setting%20modern%20cybersecurity%20concept%20editorial%20photography%20high%20detail%20sense%20of%20safety%20and%20trust%20professional%20atmosphere&width=800&height=600&seq=article-v2-04&orientation=landscape',
      link: '/cssbuy-spreadsheet-seguro',
      isInternal: true,
    },
    {
      label: 'Tutorial',
      title: 'Como Comprar no CSSBuy Sheet: Tutorial Prático',
      desc: 'Um passo a passo visual para fazer a sua primeira compra utilizando o CSSBuy Spreadsheet.',
      image: 'https://readdy.ai/api/search-image?query=Step%20by%20step%20tutorial%20displayed%20on%20tablet%20screen%20with%20shopping%20cart%20and%20product%20images%20on%20modern%20white%20desk%20with%20coffee%20cup%20nearby%20soft%20natural%20window%20lighting%20clean%20educational%20workspace%20aesthetic%20hands%20interacting%20with%20screen%20warm%20inviting%20atmosphere%20editorial%20interior%20photography%20high%20detail%20practical%20learning%20mood&width=800&height=600&seq=article-v2-05&orientation=landscape',
      link: '/como-comprar-cssbuy-sheet',
      isInternal: true,
    },
    {
      label: 'Produtos',
      title: 'Top 20 Produtos Mais Populares no CSSBuy Esta Semana',
      desc: 'Confira os itens mais procurados pelos utilizadores e as tendências atuais de compras.',
      image: 'https://readdy.ai/api/search-image?query=Trendy%20fashion%20items%20including%20sneakers%20hoodie%20and%20accessories%20beautifully%20arranged%20on%20pale%20gray%20concrete%20surface%20natural%20diffused%20lighting%20editorial%20product%20photography%20modern%20streetwear%20aesthetic%20varied%20colors%20coral%20pink%20sage%20green%20and%20cream%20tones%20fresh%20contemporary%20composition%20high%20detail%20textile%20textures%20lifestyle%20mood&width=800&height=600&seq=article-v2-06&orientation=landscape',
      link: 'https://kaspreadsheet.com',
      isInternal: false,
    },
    {
      label: 'Yupoo',
      title: 'CSSBuy Yupoo: Como Encontrar os Melhores Álbuns',
      desc: 'Guia prático para navegar nos álbuns Yupoo e encontrar produtos de qualidade através da planilha.',
      image: 'https://readdy.ai/api/search-image?query=Multiple%20product%20photo%20albums%20displayed%20as%20gallery%20grid%20on%20large%20desktop%20monitor%20screen%20modern%20white%20desk%20setup%20with%20smartphone%20beside%20it%20soft%20afternoon%20light%20from%20window%20creative%20workspace%20aesthetic%20organized%20digital%20browsing%20concept%20warm%20natural%20tones%20editorial%20interior%20photography%20high%20detail%20visual%20catalog%20mood&width=800&height=600&seq=article-v2-07&orientation=landscape',
      link: 'https://kaspreadsheet.com',
      isInternal: false,
    },
    {
      label: 'Envios',
      title: 'Custos de Envio CSSBuy: Guia Atualizado 2026',
      desc: 'Estimativas detalhadas de frete para Portugal, Brasil e outros países. Planeje seu orçamento.',
      image: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20and%20packaging%20materials%20on%20clean%20white%20desk%20with%20laptop%20showing%20delivery%20tracking%20map%20soft%20natural%20daylight%20modern%20e%20commerce%20logistics%20workspace%20aesthetic%20organized%20shipping%20station%20concept%20warm%20functional%20atmosphere%20editorial%20interior%20photography%20high%20detail%20global%20delivery%20mood&width=800&height=600&seq=article-v2-08&orientation=landscape',
      link: 'https://kaspreadsheet.com',
      isInternal: false,
    },
    {
      label: 'Comparação',
      title: 'CSSBuy vs Outros Agentes: Qual o Melhor em 2026?',
      desc: 'Comparação honesta entre CSSBuy e outros agentes de compras. Veja as diferenças.',
      image: 'https://readdy.ai/api/search-image?query=Comparison%20chart%20and%20checklist%20on%20whiteboard%20with%20laptop%20showing%20e%20commerce%20platform%20comparison%20interface%20modern%20bright%20office%20setting%20natural%20daylight%20clean%20professional%20consulting%20aesthetic%20decision%20making%20concept%20organized%20analytical%20approach%20warm%20corporate%20atmosphere%20editorial%20interior%20photography%20high%20detail%20strategic%20mood&width=800&height=600&seq=article-v2-09&orientation=landscape',
      link: 'https://kaspreadsheet.com',
      isInternal: false,
    },
    {
      label: 'Tendências',
      title: 'Tendências de Moda 2026: O Que Comprar no CSSBuy',
      desc: 'As peças que estão bombando esta temporada e onde encontrá-las na nossa planilha.',
      image: 'https://readdy.ai/api/search-image?query=Fashion%20moodboard%20with%20fabric%20swatches%20polaroid%20photos%20and%20magazine%20clippings%20on%20white%20desk%20creative%20studio%20setting%20with%20natural%20daylight%20from%20window%20stylish%20editorial%20workspace%20aesthetic%20trend%20forecasting%20concept%20warm%20earthy%20color%20palette%20sage%20green%20terracotta%20and%20cream%20tones%20artistic%20composition%20high%20detail%20fashion%20inspiration%20mood&width=800&height=600&seq=article-v2-10&orientation=landscape',
      link: 'https://kaspreadsheet.com',
      isInternal: false,
    },
    {
      label: 'Iniciantes',
      title: 'CSSBuy para Iniciantes: Tudo Que Precisa Saber',
      desc: 'Nunca usou o CSSBuy? Este guia cobre desde a criação da conta até a primeira compra.',
      image: 'https://readdy.ai/api/search-image?query=Young%20person%20learning%20on%20laptop%20with%20welcoming%20interface%20on%20screen%20modern%20bright%20home%20office%20setting%20soft%20morning%20light%20through%20window%20beginner%20friendly%20educational%20atmosphere%20clean%20white%20desk%20with%20notebook%20and%20tea%20cup%20plant%20nearby%20warm%20encouraging%20mood%20editorial%20interior%20photography%20high%20detail%20accessible%20learning%20concept&width=800&height=600&seq=article-v2-11&orientation=landscape',
      link: 'https://kaspreadsheet.com',
      isInternal: false,
    },
    {
      label: 'Avançado',
      title: 'Dicas Avançadas de CSSBuy Sheet para Experts',
      desc: 'Truques e funcionalidades pouco conhecidas que vão melhorar a sua experiência de compra.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20workspace%20with%20dual%20monitor%20setup%20displaying%20complex%20spreadsheet%20data%20and%20analytics%20charts%20modern%20tech%20office%20with%20ambient%20warm%20lighting%20sleek%20desk%20accessories%20clean%20minimalist%20aesthetic%20expert%20level%20productivity%20concept%20evening%20mood%20with%20soft%20desk%20lamp%20glow%20high%20detail%20sophisticated%20working%20atmosphere&width=800&height=600&seq=article-v2-12&orientation=landscape',
      link: 'https://kaspreadsheet.com',
      isInternal: false,
    },
  ];

  return (
    <section className="w-full bg-background-50 py-20 md:py-28">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
            <div>
              <h2 className="text-sm font-semibold text-foreground-400 uppercase tracking-wider mb-3">
                Guias &amp; Artigos SEO
              </h2>
              <h3 className="text-3xl md:text-4xl font-bold text-foreground-950 italic" style={{ fontFamily: 'var(--font-heading)' }}>
                Últimos Conteúdos
              </h3>
            </div>
            <p className="text-foreground-600 text-sm leading-relaxed max-w-md">
              Conteúdo original e otimizado para SEO sobre CSSBuy Spreadsheet. Guias práticos, dicas de segurança, tendências e tudo sobre compras internacionais para Portugal e Brasil.
            </p>
          </div>

          {/* Cards grid - 3 columns x 4 rows */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.map((article, i) => (
              <div key={article.label + i} className="group">
                {article.isInternal ? (
                  <Link to={article.link} className="block">
                    <div className="bg-background-100 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02] h-full flex flex-col">
                      <div className="h-48 overflow-hidden">
                        <img
                          src={article.image}
                          alt={article.title}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                          loading="lazy"
                        />
                      </div>
                      <div className="p-5 flex-1 flex flex-col">
                        <span className="inline-block px-3 py-1 bg-accent-100 text-accent-800 text-xs font-semibold rounded-full mb-3 self-start">
                          {article.label}
                        </span>
                        <h4 className="text-base font-bold text-foreground-950 mb-2 leading-snug">
                          {article.title}
                        </h4>
                        <p className="text-xs text-foreground-500 leading-relaxed mb-3 flex-1">
                          {article.desc}
                        </p>
                        <span className="text-xs text-accent-600 font-medium inline-flex items-center gap-1 mt-auto">
                          Ler artigo
                          <i className="ri-arrow-right-line text-xs"></i>
                        </span>
                      </div>
                    </div>
                  </Link>
                ) : (
                  <a
                    href={article.link}
                    target="_blank"
                    rel="noopener nofollow"
                    className="block"
                  >
                    <div className="bg-background-100 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02] h-full flex flex-col">
                      <div className="h-48 overflow-hidden">
                        <img
                          src={article.image}
                          alt={article.title}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                          loading="lazy"
                        />
                      </div>
                      <div className="p-5 flex-1 flex flex-col">
                        <span className="inline-block px-3 py-1 bg-accent-100 text-accent-800 text-xs font-semibold rounded-full mb-3 self-start">
                          {article.label}
                        </span>
                        <h4 className="text-base font-bold text-foreground-950 mb-2 leading-snug">
                          {article.title}
                        </h4>
                        <p className="text-xs text-foreground-500 leading-relaxed mb-3 flex-1">
                          {article.desc}
                        </p>
                        <span className="text-xs text-accent-600 font-medium inline-flex items-center gap-1 mt-auto">
                          Ver no site principal
                          <i className="ri-arrow-right-up-line text-xs"></i>
                        </span>
                      </div>
                    </div>
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}